export default function WorkHero() {
  return (
    <section className="relative bg-[#1A1A1A] pt-52 pb-24 overflow-hidden">
      {/* Background texture overlay */}
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://public.readdy.ai/ai/img_res/c6a038b9cebe58adabb9042f0c05dff3.jpg"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      {/* Gold accent line */}
      <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-gradient-to-r from-transparent via-[#C5A55A] to-transparent" />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12 text-center">
        <h1 className="text-5xl lg:text-6xl font-bold text-white mb-4 tracking-tight">Our Work</h1>
        <p className="text-xl text-[#C5A55A] font-medium">A portfolio of excellence across the region</p>
      </div>
    </section>
  );
}
